export default [{
  title: '首页',
  path: '/',
}, {
  title: '技术社区',
  href: 'https://sns.bladex.cn',
}, {
  title: '授权须知',
  path: '/doc',
}, {
  title: '应用市场',
  href: '/#/market',
}, {
  title: '商业授权',
  path: '/vip',
}, {
  title: '查询授权',
  href: '/#/license',
}, {
  title: '联系我们',
  href: '/#/contract',
}, {
  title: '官方产品',
  href: '/#/',
  children: [{
    title: '核心产品',
    href: '#',
  }, {
    title: '1. BladeX 企业级开发平台',
    href: 'https://iot.bladex.cn/vip/core/bladex.html',
  }, {
    title: '2. BladeX 物联网开发平台',
    href: 'https://iot.bladex.cn/vip/core/links.html',
  }, {
    title: '3. BladeX 可视化数据大屏',
    href: 'https://iot.bladex.cn/vip/core/visual.html',
  }, {
    title: '生态插件',
    href: '#',
  }, {
    title: '1. BladeX 低代码开发平台',
    href: 'https://bladex.cn/#/market/sucode',
  }, {
    title: '2. BladeX 工作流开发平台',
    href: 'https://bladex.cn/#/market/flow',
  }, {
    title: '3. BladeX 物联网组态系统',
    href: 'https://bladex.cn/#/market/scada',
  }]
}, {
  title: '系统演示',
  href: '/#/',
  children: [{
    title: '核心产品',
    href: '#',
  }, {
    title: '1. BladeX 企业版开发平台 (Vue3+ElementPlus)',
    href: 'https://saber3.bladex.cn',
  },{
    title: '2. BladeX 企业版开发平台 (Vue2+ElementUI)',
    href: 'https://saber.bladex.cn',
  },{
    title: '3. BladeX 企业版移动端 (Uniapp+Uview)',
    href: 'https://rider.bladex.cn/preview.png',
  }, {
    title: '4. BladeX 数据大屏 (BladeX+AvueData)',
    href: 'https://data.bladex.cn',
  }, {
    title: '5. BladeX 物联网平台 (BladeX+MicaMqtt)',
    href: 'https://iot.javablade.com',
  }, {
    title: '生态插件',
    href: '#',
  }, {
    title: '1. BladeX 低代码平台 (BladeX+FormMaking)',
    href: 'https://demo.suconnect.com/',
  }, {
    title: '2. BladeX 工作流平台 (BladeX+Flowable)',
    href: 'https://demo3.nutflow.vip/',
  }, {
    title: '3. BladeX 物联网组态 (BladeX+AvueData)',
    href: 'https://scada.bladex.cn/',
  }]
}]
